import * as PIXI from 'pixi.js';
import { DropShadowFilter } from 'pixi-filters';
import { ScrollBox } from '@pixi/ui';
import { CARD_WIDTH, CARD_HEIGHT, getProxiedCardImageUrl } from '../utils/commonUtils';
import { getGlobalEventEmitter } from '../utils/globalEventEmitter';

export default class TrashOverlayContainer extends PIXI.Container {
    constructor(isPlayer) {
        super();

        const gradient1 = new PIXI.FillGradient({
            type: 'linear',
            start: { x: 0, y: 0.5 },
            end: { x: 1, y: 0.5 },
            colorStops: [
                { offset: 0, color: '#1b110d' },
                { offset: 0.4, color: '#463422' },
                { offset: 0.6, color: '#463422' },
                { offset: 1, color: '#1b110d' },
            ],
        });

        const shadowFilter = new DropShadowFilter({
            color: '#000000',
            blur: 10,
            quality: 8,
            offsetX: 20,
            offsetY: 20,
            alpha: 1,
        });

        const backgroundGraphics = new PIXI.Graphics();
        backgroundGraphics.label = 'backgroundGraphics';
        backgroundGraphics.roundRect(0, 0, CARD_WIDTH + 40, CARD_HEIGHT * 3.5, 15);
        backgroundGraphics.stroke({ color: '#c69e54', width: 10 });
        backgroundGraphics.fill(gradient1);
        backgroundGraphics.filters = [shadowFilter];
        this.addChild(backgroundGraphics);

        const scrollBox = new ScrollBox({
            width: CARD_WIDTH + 40,
            height: CARD_HEIGHT * 3.5,
            // background: 0XFFFFFF,
            padding: 20,
            elementsMargin: 10,
            items: [
            ]
        });
        scrollBox.label = 'scrollBox';
        scrollBox.x = 0;
        scrollBox.y = 0;
        this.addChild(scrollBox);

        this.pivot.set(CARD_WIDTH / 2 + 20, isPlayer ? CARD_HEIGHT * 3.5 : 0);
    }

    update(playerState) {
        const scrollBox = this.getChildByLabel('scrollBox');
        scrollBox.removeItems();
        scrollBox.onScroll.disconnectAll();

        const reversedTrash = [...playerState.trash].reverse();

        for (const card of reversedTrash) {
            const cardSprite = new PIXI.Sprite(PIXI.Assets.get(getProxiedCardImageUrl(card.imgUrl)));
            cardSprite.width = CARD_WIDTH;
            cardSprite.height = CARD_HEIGHT;

            let cardHeldTimeout;
            cardSprite.on('pointerdown', (event) => {
                cardHeldTimeout = setTimeout(() => {
                    getGlobalEventEmitter()?.emit('cardHeld', { cardInstance: card });
                    cardHeldTimeout = null;
                }, 700);
            });

            cardSprite.on('pointerup', (event) => {
                clearTimeout(cardHeldTimeout);
                cardHeldTimeout = null;
            });

            cardSprite.on('pointerupoutside', (event) => {
                clearTimeout(cardHeldTimeout);
                cardHeldTimeout = null;
            });

            scrollBox.onScroll.connect(() => {
                clearTimeout(cardHeldTimeout);
                cardHeldTimeout = null;
            });
            
            scrollBox.addItem(cardSprite);
        }
    }
}